import React from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();

  // If no user is logged in, don't render header
  const showHeader = location.pathname !== "/login";

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFA] text-neutral-800">
      {showHeader && user && (
        <Header userRole={user.role} />
      )}

      <main className="flex-1 bg-[#F8FAFA] p-4 pt-20">{children}</main>
    </div>
  );
};

export default Layout;
